// TODO: Remove all the additional non-functioning methods from the client
import awsmobile from '../config/aws-exports.js';

export const getFetchOptions = () => ({
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': awsmobile.location_api_key,
  },
});

export const fetchRequest = async apiUrl =>
  await fetch(apiUrl, getFetchOptions()).then(async res => {
    if (res.status !== 200) {
      throw new Error(await res.text());
    }
    return res.json();
  });

export const getAddressesByPostcode = async postcode => {
  const preppedPostcode = postcode.replace(' ', '').trim();
  const response = await fetch(
    `${awsmobile.location_endpoint_auth}/addresses/${preppedPostcode}`,
    getFetchOptions(),
  ).then(res => res.json());

  if (response.addresses.length === 0) {
    /**
     * TODO:
     * Replace the following if condition with one referencing the API response
     * once that differentiates between invalid postcodes and non-mainland ones
     */
    if (postcode.match(/^(BT|IM|GY|JE|HS|KA2(7|8)|KW|BF|ZE|PH|IV)/i)) {
      throw new Error(
        'Our tariff database only covers the UK mainland.\nPlease enter a mainland postcode to continue.',
      );
    } else {
      throw new Error('Could not find any homes for postcode: ' + postcode);
    }
  }

  return response;
};

export const getMeterDetailsForAddressId = async addressId =>
  await fetchRequest(
    `${awsmobile.location_endpoint_auth}/meterDetails/${addressId}`,
  );

export const fakeRejectedRequest = async () => await new Promise().reject();

export const getRegion = async postcode =>
  await fetchRequest(
    `${awsmobile.location_endpoint_auth}/distributionId/${postcode}`,
  );
